import React from "react";
import { UpdateParameterValues } from "../services/City";
function ConstructionCostV(props) {
  const [value, setValue] = React.useState(null);
  const [IsStyle, SetStyle] = React.useState("form-control  construction construction");
  const [structureType, SetstructureType] = React.useState("Per Home");
  React.useEffect(() => {
    if (props.structureType == "Single Family") { SetstructureType("Per Lot") }
    if (props.structureType == "Apartment" || props.structureType == "Condo") { SetstructureType("Per Unit") }
    if (props.value == "") {
      setValue(0);
    }
    else {
      setValue(props.value);
    }

    if (props.id == 198) {
      SetStyle("form-control  construction construction leftTop");
    }
    if (props.id == 229) {
      SetStyle("form-control  construction construction RightTop");
    }
    if (props.id == 239) {
      SetStyle("form-control  construction construction RightTop");
    }
    if (props.id == 712850) {
      console.log(props)
    }

  }, []);
  const onChange = (e) => {
    setValue(e.target.value);
    let checkid = e.target.id;
    let parameterid = checkid.split('-')[1]
    let structuretype = "";
    if (checkid.includes("Single Family")) {
      structuretype = "Single Family"
    }
    if (checkid.includes("Townhome")) {
      structuretype = "Townhome"
    }
    if (checkid.includes("Cottage")) {
      structuretype = "Cottage"
    }
    if (checkid.includes("Rowhouse")) {
      structuretype = "Rowhouse"
    }
    if (checkid.includes("Condo")) {
      structuretype = "Condo"
    }
    if (checkid.includes("Apartment")) {
      structuretype = "Apartment"
    }
    UpdateParameterValues(structuretype, props);
  }

  if (props.id == 207) {
    return (
      <>
        <div class="row" style={{ borderTop: "1px solid rgba(0, 0, 0, 0.2)", width: "100%" }}>
          <div class="col-md-4" ></div>
          <div class="col-md-4 col-7" style={{ marginTop: "3%" }}>
            <div class="from  justify-content-between  align-items-center ">
              <label class="" style={{ marginTop: "5%" }}>{props.name.split('Per')[0]}
              </label>



            </div>
          </div>

          <div class="col-md-3 col-5" id={"row-" + props.structureType + "-" + props.id} style={{ marginTop: "3%" }}>
            <div class="test from  justify-content-between  align-items-center ">

              <input
                type="text"
                key={props.structureType + "-" + props.id}
                id={props.structureType + "-" + props.id}
                value={value}


                //placeholder={props.name.split('Per')[0]}
                readOnly
                class="form-control  construction"
                style={{ borderRadius: "5px", fontWeight: "550" }}
              />

            </div>
          </div>
        </div>

      </>
    );
  }
  if (props.wholeEl.ParameterTypeId == 11 || props.wholeEl.ParameterTypeId == 12) {
    if (props.wholeEl.ParameterTypeId == 11) {
      if (props.data.find((item) => item.ParameterId == 287 && item.structureType == props.structureType).value != "False") {

        if (props.name != "" && props.name != null) {
          return (
            <>
              <div class="col-md-3 "  >
                <div class="from   align-items-center ">
                  <label >{props.name}
                  </label>


                </div>
              </div>
              <div class="col-md-2 col-2" >
                <div class="from  justify-content-between  align-items-center ">
                  <div class="test">
                    <input
                      type="text"
                      key={props.structureType + "-" + props.id + "-persqt-soft"}
                      id={props.structureType + "-" + props.id + "-persqt-soft"}
                      value={props.wholeEl.value}
                      readOnly
                      //placeholder={props.name.split('Per')[0]}
                      class={IsStyle + props.structureType + " " + props.name.replace(" ", "") + " advsoftcost persqt"}
                      style={{}}
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-3 col-5">
                <div class="from  justify-content-between  align-items-center ">
                  <div class="test">
                    <input
                      type="text"
                      key={props.structureType + "-" + props.id + "-perhome-soft"}
                      id={props.structureType + "-" + props.id + "-perhome-soft"}
                      value={props.wholeEl.perhomevalue}
                      readOnly
                      class={IsStyle + props.structureType + " " + props.name.replace(" ", "") + " advsoftcost perhome"}
                      style={{}}
                    />
                  </div> </div>
              </div>
              <div class="col-md-3 col-5" id={"row-" + props.structureType + "-" + props.id}>
                <div class="from   justify-content-between  align-items-center ">
                  <div class="test">
                    <input
                      type="text"
                      key={props.structureType + "-" + props.id + "-perproject-soft"}
                      id={props.structureType + "-" + props.id + "-perproject-soft"}
                      value={props.wholeEl.perprojectvalue}
                      readOnly
                      class={IsStyle + props.structureType + " " + props.name.replace(" ", "") + " advsoftcost perproject"}
                      style={{}}
                    />
                  </div> </div>
              </div>
            </>
          );
        }
      }
      else {
        return (<></>);
      }
    }

    if (props.wholeEl.ParameterTypeId == 12) {
      if (props.data.find((item) => item.ParameterId == 288 && item.structureType == props.structureType).value != "False") {

        if (props.name != "" && props.name != null) {
          return (
            <>
              <div class="col-md-3" id={"row-" + props.structureType + "-" + props.id}  >
                <div class="from   align-items-center ">

                  {/* <label class="" style={{marginLeft:"10%"}} contenteditable="true">{props.name}      
  
            </label> */}
                  <label >{props.name}
                  </label>
                </div>
              </div>
              <div class="col-md-2 col-2" >
                <div class="from   justify-content-between  align-items-center ">
                  <div class="test">
                    <input
                      type="text"
                      key={props.structureType + "-" + props.id + "-persqt-hard"}
                      id={props.structureType + "-" + props.id + "-persqt-hard"}
                      value={props.wholeEl.value}
                      //placeholder={props.name.split('Per')[0]}
                      readOnly
                      class={IsStyle + props.structureType + " " + props.name.replace(" ", "") + " advhardcost persqt"}
                      style={{}}
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-3 col-5" id={"row-" + props.structureType + "-" + props.id}>
                <div class="from   justify-content-between  align-items-center ">
                  <div class="test">
                    <input
                      type="text"
                      key={props.structureType + "-" + props.id + "-perhome-hard"}
                      id={props.structureType + "-" + props.id + "-perhome-hard"}
                      value={props.wholeEl.perhomevalue}
                      readOnly
                      class={IsStyle + props.structureType + " " + props.name.replace(" ", "") + " advhardcost perhome"}
                      style={{}}
                    />
                  </div> </div>
              </div>
              <div class="col-md-3 col-5">
                <div class="from  justify-content-between  align-items-center ">
                  <div class="test">
                    <input
                      type="text"
                      key={props.structureType + "-" + props.id + "-perproject-hard"}
                      id={props.structureType + "-" + props.id + "-perproject-hard"}
                      value={props.wholeEl.perprojectvalue}
                      readOnly
                      class={IsStyle + props.structureType + " " + props.name.replace(" ", "") + " advhardcost perproject"}
                      style={{}}
                    />
                  </div> </div>
              </div>
            </>
          );
        }
      }
      else {
        return (<></>);
      }
    }




  }
  if (props.id == 313 || props.id == 303) {
    return (
      <>
        <div class="col-md-5" id={"row-" + props.structureType + "-" + props.id}>
          <div class="from   justify-content-between  align-items-center ">
            <label class="">{props.name.split('per')[0]}

            </label>
          </div>
        </div>
        <div class="col-2 ismobile"></div>
        <div class="col-md-3 col-5" id={"row1-" + props.structureType + "-" + props.id}>
          <div class="from   justify-content-between  align-items-center ">
            <div class="test">
              <input

                type="text"
                key={props.structureType + "-" + props.id}
                id={props.structureType + "-" + props.id}
                value={value}

                //placeholder={props.name.split('Per')[0]}
                readOnly
                class={IsStyle}
                style={{ boxShadow: "none", fontWeight: "550", borderTop: "2px solid" }}
              />
            </div>
          </div>
        </div>
      </>
    );
  }
  if (props.id == 309 || props.id == 311 || props.id == 310) {
    return (
      <>
        <div class="col-md-3" id={"row-" + props.structureType + "-" + props.id}>
          <div class="from   justify-content-between  align-items-center ">
            <label class="">{props.name.split('per')[0]}

            </label>
          </div>
        </div>
        <div class="col-md-2 col-2" id={"row1-" + props.structureType + "-" + props.id}>
          <div class="from   justify-content-between  align-items-center ">
            <div class="test">
              <input

                type="text"
                key={props.structureType + "-" + props.id}
                id={props.structureType + "-" + props.id}
                value={value}
                readOnly
                //placeholder={props.name.split('Per')[0]}

                class={IsStyle}

              />
            </div>
          </div>
        </div>
      </>
    );
  }
  if (props.id == 314 || props.id == 304) {
    return (
      <>

        <div class="col-md-3 col-5" id={"row1-" + props.structureType + "-" + props.id}>
          <div class="from   justify-content-between  align-items-center ">
            <div class="test">
              <input

                type="text"
                key={props.structureType + "-" + props.id}
                id={props.structureType + "-" + props.id}
                value={value}

                //placeholder={props.name.split('Per')[0]}
                readOnly
                class={IsStyle}
                style={{ boxShadow: "none", fontWeight: "550", borderTop: "2px solid" }}
              />
            </div>
          </div>
        </div>
      </>
    );
  }
  if (props.id == 287 || props.id == 288) {
    return (<></>);

  }
  if (props.id == 88 || props.id == 89 || props.id == 91 || props.id == 105 || props.id == 90 || props.id == 106 || props.id == 87 || props.id == 128 || props.id == 126 || props.id == 107) {
    if (props.id == 128 || props.id == 126 || props.id == 107) {
      return (

        <>
          <div class="col-md-5" >
            <div class="from  justify-content-between  align-items-center ">
              <label class=""><u>{props.name.split('Per')[0]} </u>
              </label>



            </div>
          </div>
          <div class="col-2 ismobile"></div>
          <div class="col-md-3 col-5" id={"row-" + props.structureType + "-" + props.id}>
            <div class="test from  justify-content-between  align-items-center ">

              <input
                type="text"
                key={props.structureType + "-" + props.id}
                id={props.structureType + "-" + props.id}
                value={value}


                //placeholder={props.name.split('Per')[0]}
                readOnly
                class="form-control  construction"
                style={{ boxShadow: "none", fontWeight: "550", borderTop: "2px solid", borderBottomLeftRadius: "5px" }}
              />

            </div>
          </div>
        </>
      );
    }
    else {

      return (
        <>
          <div class="col-md-5">
            <div class="from  justify-content-between  align-items-center ">
              <label class="">{props.name.split('Per')[0]}

              </label>



            </div>
          </div>
          <div class="col-2 ismobile"></div>
          <div class="col-md-3 col-5" id={"row-" + props.structureType + "-" + props.id}>
            <div class="from  justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}

                  readOnly
                  class="form-control  construction"
                />
              </div>
            </div>
          </div></>
      );

    }
  }
  // if(props.id==294)
  // {
  //   return (
  //   <>
  //   <div class="col-md-12 text-center input-box1 mt-3" >
  //   <div class="row" style={{width:"107%"}}>
  //   <div class="col-md-5"></div>
  //   <div class="col-md-3"><label class="d-inherit text-center">{structureType}</label></div>
  //   <div class="col-md-3"><label class="d-inherit text-center">Project</label></div>
  //   </div></div>
  //   <div class="col-md-5">
  //           <div class="from  justify-content-between  align-items-center ">
  //             <label class="">{props.name.split('Per')[0]}</label>
  //           </div>
  //           </div> 
  //             <div class="col-md-3">
  //             <div class="from   justify-content-between  align-items-center ">
  //             <div class="test">
  //             <input type="text"
  //              key={props.structureType +"-"+ props.id}
  //              id={props.structureType +"-"+ props.id}
  //             value={value}
  //             readOnly
  //               class="form-control  construction"
  //             style={{borderTopLeftRadius:"5px"}}
  //             />
  //            </div>
  //           </div>
  //           </div>
  //       </>
  //   );
  // }
  if (props.id == 296 || props.id == 299 || props.id == 302 || props.id == 308) {
    if (props.id == 296) {

      return (

        <>


          <div class="col-md-1 col-2" >
            <div class="from   justify-content-between  align-items-center ">
              <div class="test2">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  readOnly
                  class="form-control  construction"
                //placeholder={props.name.split('Per')[0]}



                />
              </div>
            </div>
          </div>
        </>
      );
    }
    else {


      return (

        <>


          <div class="col-md-1 col-2" >
            <div class="from   justify-content-between  align-items-center ">
              <div class="test2">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  readOnly
                  class="form-control  construction"

                />
              </div>
            </div>
          </div>
        </>
      );
    }
  }
  if (props.id == 295 || props.id == 298 || props.id == 301 || props.id == 307) {
    return (

      <>


        <div class="col-md-2 col" >
          <div class="from   justify-content-between  align-items-center ">
            <div class="test">
              <input
                type="text"
                key={props.structureType + "-" + props.id}
                id={props.structureType + "-" + props.id}
                value={value}
                readOnly
                class="form-control  construction"

              />
            </div>
          </div>
        </div>
      </>
    );
  }
  if (props.id == 297 || props.id == 300 || props.id == 294 || props.id == 302) {
    return (
      <>

        <div class="col-md-5">
          <div class="from   justify-content-between  align-items-center ">
            <label class="">{props.name.split('Per')[0]}</label>
          </div>
        </div>
        <div class="col-2 ismobile"></div>
        <div class="col-md-3 col-5">
          <div class="from   justify-content-between  align-items-center ">
            <div class="test">
              <input type="text"
                key={props.structureType + "-" + props.id}
                id={props.structureType + "-" + props.id}
                value={value}
                readOnly
                class="form-control  construction"
              />
            </div>
          </div>
        </div>
      </>
    );
  }
  if (props.id == 289 || props.id == 290) {
    return (
      <>
        <div class="col-md-12 input-box1 mt-3">
          <div class="row" style={{ width: "107%" }}>
            <div class="col-md-3" id={"row-" + props.structureType + "-" + props.id}></div>
            <div class="col-md-2 col-2" id={"row1-" + props.structureType + "-" + props.id}><label class="d-block text-center">Per sqft</label></div>
            <div class="col-md-3 col-5" id={"row-" + props.structureType + "-" + props.id}><label class="d-block text-center">{structureType}</label></div>
            <div class="col-md-3 col-5" id={"row-" + props.structureType + "-" + props.id}><label class="d-block text-center">Project</label></div>
          </div></div>

      </>
    );
  }
  if (props.id == 305) {


    return (
      <>
        <div class="col-md-3" id={"row-" + props.structureType + "-" + props.id}>
          <div class="from   align-items-center ">
            <label class="">{props.name.split('per')[0]}

            </label>



          </div>
        </div>
        <div class="col-md-2 col-2" id={"row1-" + props.structureType + "-" + props.id}>
          <div class="from   justify-content-between  align-items-center ">
            <div class="test">
              <input

                type="text"
                key={props.structureType + "-" + props.id}
                id={props.structureType + "-" + props.id}
                value={value}
                readOnly
                //placeholder={props.name.split('Per')[0]}

                class={IsStyle}
              //style={{ backgroundColor:"#e7f0fa" }}
              />
            </div>
          </div>
        </div></>
    );

  }
  if (props.id == 186) {



    return (
      <>
        <div class="col-md-3" id={"row-" + props.structureType + "-" + props.id}>
          <div class="from   align-items-center ">
            <label class="">{props.name.split('Per')[0]}

            </label>



          </div>
        </div>
        <div class="col-md-2 col-2" id={"row1-" + props.structureType + "-" + props.id}>
          <div class="from   justify-content-between  align-items-center ">
            <div class="test">
              <input

                type="text"
                key={props.structureType + "-" + props.id}
                id={props.structureType + "-" + props.id}
                value={value}
                readOnly
                class="form-control  construction"
              />
            </div>
          </div>
        </div></>
    );

  }
  else if (props.id == 198 || props.id == 110 || props.id == 230 || props.id == 112 || props.id == 111 || props.id == 114 || props.id == 113 || props.id == 115 || props.id == 109 || props.id == 240) {
    if (props.id == 230) {


      return (
        <>
          <div class="col-md-3" id={"row-" + props.structureType + "-" + props.id}>
            <div class="from  justify-content-between  align-items-center ">
              <label class=""><u>{props.name.split('Per')[0]}</u>
              </label>



            </div>
          </div>
          <div class="col-md-2 col-2" id={"row1-" + props.structureType + "-" + props.id}>
            <div class="test from  justify-content-between  align-items-center ">

              <input
                type="text"
                key={props.structureType + "-" + props.id}
                id={props.structureType + "-" + props.id}
                value={value}


                //placeholder={props.name.split('Per')[0]}
                readOnly
                class="form-control  construction"
                style={{ boxShadow: "none", fontWeight: "550", borderTop: "2px solid", borderBottomLeftRadius: "5PX" }}
              />

            </div>
          </div>
        </>
      );

    }
    else {
      if (props.id == 110 || props.id == 112 || props.id == 111 || props.id == 114 || props.id == 113) {

        return (
          <>
            <div class="col-md-3" id={"row-" + props.structureType + "-" + props.id}>
              <div class="from  justify-content-between  align-items-center ">
                <label class="">{props.name.split('Per')[0]}

                </label>



              </div>
            </div>
            <div class="col-md-2 col-2" id={"row1-" + props.structureType + "-" + props.id}>
              <div class="from  justify-content-between  align-items-center ">
                <div class="test">
                  <input
                    type="text"
                    key={props.structureType + "-" + props.id}
                    id={props.structureType + "-" + props.id}
                    value={value}
                    onChange={onChange}

                    //placeholder={props.name.split('Per')[0]}
                    readOnly
                    class={IsStyle}
                    style={{ borderTopLeftRadius: "5px", borderBottomLeftRadius: "5px" }}
                  />
                </div>
              </div>
            </div>
          </>
        );

      }
      else if (props.id == 115 || props.id == 240) {



        return (
          <>
            <div class="col-md-3" id={"row-" + props.structureType + "-" + props.id}>
              <div class="from  justify-content-between  align-items-center ">
                <label class="">{props.name.split('Per')[0]}
                </label>



              </div>
            </div>
            <div class="col-md-2 col-2" id={"row1-" + props.structureType + "-" + props.id}>
              <div class="from  justify-content-between  align-items-center ">
                <div class="test">
                  <input
                    type="text"
                    key={props.structureType + "-" + props.id}
                    id={props.structureType + "-" + props.id}
                    value={value}
                    onChange={onChange}

                    //placeholder={props.name.split('Per')[0]}
                    readOnly
                    class={IsStyle}
                    style={{}}
                  />
                </div>
              </div>
            </div></>
        );

      }

      else {

        return (
          <>
            <div class="col-md-3" id={"row-" + props.structureType + "-" + props.id}>
              <div class="from  justify-content-between  align-items-center ">
                <label class="">{props.name.split('Per')[0]}

                </label>



              </div>
            </div>
            <div class="col-md-2 col-2" id={"row1-" + props.structureType + "-" + props.id}>
              <div class="from  justify-content-between  align-items-center ">
                <div class="test">
                  <input
                    type="text"
                    key={props.structureType + "-" + props.id}
                    id={props.structureType + "-" + props.id}
                    value={value}
                    onChange={onChange}

                    //placeholder={props.name.split('Per')[0]}
                    readOnly
                    class={IsStyle}
                    style={{}}
                  />
                </div>
              </div>
            </div></>
        );
      }
    }


  }
  else {
    if (props.id == 231 || props.id == 203 || props.id == 108) {

      if (props.id == 231) {
        return (<>

          <div class="col-md-3 col-5" id={"row-" + props.structureType + "-" + props.id} style={{ marginBottom: "5%" }}>
            <div class="test from  justify-content-between  align-items-center ">

              <input
                type="text"
                key={props.structureType + "-" + props.id}
                id={props.structureType + "-" + props.id}
                value={value}

                //placeholder={props.name.split('Per')[0]}
                readOnly
                class="form-control  construction"
                style={{ boxShadow: "none", fontWeight: "550", borderTop: "2px solid" }}
              />

            </div>
          </div></>);
      }
      if (props.id == 108) {
        return (<>

          <div class="col-md-3 col-5" style={{ marginBottom: "5%" }}>
            <div class="from   justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}

                  readOnly
                  class="form-control construction"
                  style={{ boxShadow: "none", fontWeight: "550", borderTop: "2px solid", borderBottomRightRadius: "5px" }}
                />
              </div>
            </div>
          </div></>);
      }
      else {
        return (
          <>

            <div class="col-md-3 col-5" id={"row-" + props.structureType + "-" + props.id} style={{ marginBottom: "5%" }}>
              <div class="test from  justify-content-between  align-items-center ">
                <div class="test">
                  <input
                    type="text"
                    key={props.structureType + "-" + props.id}
                    id={props.structureType + "-" + props.id}
                    value={value}


                    //placeholder={props.name.split('Per')[0]}
                    readOnly
                    class="form-control  construction"
                    style={{ boxShadow: "none", fontWeight: "550", borderTop: "2px solid" }}
                  />
                </div>
              </div>
            </div></>
        );
      }

    }
    else {

      return (
        <div class="col-md-3 col-5" id={"row-" + props.structureType + "-" + props.id}>
          <div class="from  justify-content-between  align-items-center ">

            <div class="test">
              <input
                type="text"
                key={props.structureType + "-" + props.id}
                id={props.structureType + "-" + props.id}
                value={value}


                //placeholder={props.name.split('Per')[0]}
                readOnly
                class={IsStyle}
                style={{}}
              />
            </div> </div>
        </div>
      );

    }


  }
}

export default ConstructionCostV;
